import React from "react";
import { 
  TextField, 
  Typography, 
  Button, 
  makeStyles, 
  Grid,
  FormControlLabel,
  Switch,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  section: {
    marginBottom: theme.spacing(4),
  },
  templateButton: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const scriptTemplates = [
  {
    label: "Vender un Producto",
    text: "¡Hola! ¿Cansado de perder el tiempo? Descubre hoy cómo nuestro nuevo [Nombre del Producto] puede transformar tu día a día. Haz clic abajo para más información y obtén un 20% de descuento."
  },
  {
    label: "Invitación a Webinar",
    text: "Te invito a nuestro próximo webinar gratuito sobre [Tema]. Aprenderás las 3 claves principales para dominar esta habilidad. Reserva tu lugar haciendo clic en el enlace."
  },
  {
    label: "Anuncio de Noticia",
    text: "¡Última hora! Acabamos de lanzar la nueva actualización de [Servicio]. Ahora es más rápido, seguro y fácil de usar. Entra a nuestra web y pruébalo gratis."
  }
];

const StepScript = ({ formData, updateFormData }) => {
  const classes = useStyles();

  const handleTemplateClick = (text) => {
    updateFormData("script", text);
  };

  return (
    <div>
      <div className={classes.section}>
        <Typography variant="h6" gutterBottom>
          El Guion (Lo que dirá el personaje)
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
          Escribe lo que quieres que hable tu avatar. Puedes empezar usando una de nuestras plantillas rápidas.
        </Typography>

        <div style={{ marginBottom: 16 }}>
          {scriptTemplates.map((tpl, i) => (
            <Button
              key={i}
              variant="outlined"
              color="primary"
              size="small"
              className={classes.templateButton}
              onClick={() => handleTemplateClick(tpl.text)}
            >
              Plantilla: {tpl.label}
            </Button>
          ))}
        </div>

        <TextField
          label="Escribe el guion exacto..."
          multiline
          rows={6}
          variant="outlined"
          fullWidth
          value={formData.script}
          onChange={(e) => updateFormData("script", e.target.value)}
          placeholder="Ej: Hola, quiero mostrarte este increíble producto..."
        />
      </div>

      <div className={classes.section}>
        <Typography variant="h6" gutterBottom>
          Extras (Música y Subtítulos)
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch 
                  checked={formData.useSubtitles} 
                  onChange={(e) => updateFormData("useSubtitles", e.target.checked)} 
                  color="primary" 
                />
              }
              label="Quemar Subtítulos estilo TikTok"
              style={{ display: "block" }}
            />
            <FormControlLabel
              control={
                <Switch 
                  checked={formData.useMusic} 
                  onChange={(e) => updateFormData("useMusic", e.target.checked)} 
                  color="primary" 
                />
              }
              label="Añadir Música de Fondo"
              style={{ display: "block" }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            {formData.useMusic && (
              <FormControl variant="outlined" fullWidth size="small">
                <InputLabel>Pista de Música</InputLabel>
                <Select
                  value={formData.musicTrack}
                  onChange={(e) => updateFormData("musicTrack", e.target.value)}
                  label="Pista de Música"
                >
                  <MenuItem value="corporate">Corporativa (Inspiradora)</MenuItem>
                  <MenuItem value="lofi">Lo-Fi (Relajante)</MenuItem>
                  <MenuItem value="viral">Viral / Upbeat (Energética)</MenuItem>
                  <MenuItem value="epic">Cinemática (Épica)</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default StepScript;
